module.exports = __webpack_public_path__ + "media/packs/user-cards/images/edit-035ba6977749c9bd5697e584d822a037.svg";